import React from 'react';
import CertificationVerifiedSvg from '../../Images/CertificationVerifiedSvg';
import { CertificationGroupType } from '@wix/wix-studio-marketplace-lib';

export const CERTIFICATION_GROUP_COLORS: Partial<
  Record<CertificationGroupType, string>
> = {
  DESIGNER: '#E5DFF7',
  DEVELOPER: '#B8F7D3',
  VELO: '#BBECDF',
  ACCESSIBILITY: '#D4E2F7',
};

export const DEFAULT_CERTIFICATION_GROUP_COLOR = '#BBECDF';

export const CERTIFICATION_GROUP_LABELS: Partial<
  Record<CertificationGroupType, string>
> = {
  DESIGNER: 'profile-page-certification-group-web-designer',
  DEVELOPER: 'profile-page-certification-group-developer',
  VELO: 'profile-page-certification-group-velo-developer',
  ACCESSIBILITY: 'profile-page-certification-group-accessibility',
};

export const CertificationGroupIcon = ({
  width = 18,
  height = 18,
}: {
  width?: number;
  height?: number;
}) => React.createElement(CertificationVerifiedSvg, { width, height });

export const getCertificationGroupColor = (
  group: CertificationGroupType,
): string => {
  return CERTIFICATION_GROUP_COLORS[group] || DEFAULT_CERTIFICATION_GROUP_COLOR;
};

export const getCertificationGroupLabel = (
  group: CertificationGroupType,
): string => {
  return CERTIFICATION_GROUP_LABELS[group] || '';
};

export const isCertificationGroup = (
  group: CertificationGroupType,
): boolean => {
  return Boolean(CERTIFICATION_GROUP_LABELS[group]);
};
